import { getMinCosts } from './getMinCosts'

export default {
  ...getMinCosts
}
